import BaseCachedDataService from '@/core/services/cachedData/BaseCachedDataService'
import { SelectedAccountsEntityListData } from '@/types/entities'
import { DEFAULT_ENTITIES_DATA } from '@/enum/defaultEntitiesData'
import { entitiesApi } from '@/api/entitiesApi'

class SelectedAccountDataEntitiesService extends BaseCachedDataService<SelectedAccountsEntityListData> {
    constructor () {
        super({ 0: DEFAULT_ENTITIES_DATA } )
    }

    async loadData (id: number) {
        const res = await entitiesApi.getSelectedAccountList(id)

        if (!res) {
            return this.data = { [id]: DEFAULT_ENTITIES_DATA }
        }

        return this.data = {
            [id]: {
                ...res,
            }
        }
    }
}

export default new SelectedAccountDataEntitiesService()
